
import {
  SupplierDto,
  CreateSupplierDto,
  UpdateSupplierDto,
  SupplierType,
} from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { PaginatedQueryBase } from './api'

export type SuppliersFilters = PaginatedQueryBase & {
  includeInactive?: boolean
  search?: string
  type?: SupplierType
}

class SupplierService extends BaseCrudService<
  SupplierDto,
  CreateSupplierDto,
  UpdateSupplierDto,
  SuppliersFilters
> {
  constructor() {
    super('supplier', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }
}

export const supplierService = new SupplierService()
